<div class="payment-dialog" [class.payment-dialog--expanded]="stateDropdownOpen">
  <div class="payment-dialog__header">
    <h1 class="payment-dialog__title">Add Payment Method</h1>
    <button class="dialog-close" (click)="dialogRef.close()" type="button" aria-label="Close dialog">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="payment-dialog__content">
    @if (submittingPayment) {
    <div class="progress-spinner-wrapper">
      <div class="progress-spinner"></div>
    </div>
    }

    <form [formGroup]="billingFormGroup" class="payment-dialog__body" [class.collect-js-hidden]="submittingPayment">
      <div class="payment-dialog__col-left">
        <div class="field-row">
          <div class="field">
            <label class="field__label">First Name*</label>
            <input class="field__input" type="text" id="firstName" formControlName="firstName" name="firstName"
              required>
            @if (billingFirstName.invalid && (billingFirstName.dirty || billingFirstName.touched)) {
            @if (billingFirstName?.errors.required) {
            <span class="field__error">First Name is required</span>
            }
            }
          </div>
          <div class="field">
            <label class="field__label">Last Name*</label>
            <input class="field__input" type="text" id="lastName" formControlName="lastName" name="lastName" required>
            @if (billingLastName.invalid && (billingLastName.dirty || billingLastName.touched)) {
            @if (billingLastName?.errors.required) {
            <span class="field__error">Last Name is required</span>
            }
            }
          </div>
        </div>

        <div class="field">
          <label class="field__label">Address*</label>
          <input class="field__input" type="text" id="address" formControlName="address" name="address" required>
          @if (billingAddress.invalid && (billingAddress.dirty || billingAddress.touched)) {
          @if (billingAddress?.errors.required) {
          <span class="field__error">Address is required</span>
          }
          }
        </div>

        <div class="field-row">
          <div class="field field--city">
            <label class="field__label">City*</label>
            <input class="field__input" type="text" id="city" formControlName="city" name="city" required>
            @if (billingCity.invalid && (billingCity.dirty || billingCity.touched)) {
            @if (billingCity?.errors.required) {
            <span class="field__error">City is required</span>
            }
            }
          </div>
          <div class="field field--state">
            <label class="field__label">State*</label>
            <div class="custom-select" [class.custom-select--open]="stateDropdownOpen"
              (click)="stateDropdownOpen = !stateDropdownOpen">
              <span class="custom-select__value">
                {{billingState.value ? getStateName(billingState.value) : 'Select state'}}
              </span>
              <span class="material-symbols-outlined custom-select__arrow">expand_more</span>
              @if (stateDropdownOpen) {
              <div class="custom-select__dropdown">
                @for (st of stateOptions; track st) {
                <div class="custom-select__option" (click)="selectState(st.abbreviation); $event.stopPropagation()">
                  {{st.name}}
                </div>
                }
              </div>
              }
            </div>
            @if (billingState.invalid && (billingState.dirty || billingState.touched)) {
            @if (billingState?.errors.required) {
            <span class="field__error">State is required.</span>
            }
            }
          </div>
          <div class="field field--zip">
            <label class="field__label">Zip Code*</label>
            <input class="field__input" type="text" id="zip" formControlName="zip" name="zip" pattern="\d\d\d\d\d"
              required>
            @if (billingZip.invalid && (billingZip.dirty || billingZip.touched)) {
            @if (billingZip?.errors.required) {
            <span class="field__error">Zip Code is required.</span>
            }
            @if (billingZip?.errors.pattern) {
            <span class="field__error">Enter a valid Zip Code.</span>
            }
            }
          </div>
        </div>

        <div class="field">
          <label class="field__label">Phone Number*</label>
          <input class="field__input" type="text" formControlName="phone" name="phone" mask="000-000-0000"
            [showMaskTyped]="true" required>
          @if (billingPhone.invalid && (billingPhone.dirty || billingPhone.touched)) {
          @if (billingPhone?.errors.required) {
          <span class="field__error">Phone Number is required</span>
          }
          @if (billingPhone?.errors.pattern) {
          <span class="field__error">Not enough digits</span>
          }
          }
        </div>
      </div>

      <div class="payment-dialog__col-right" [class.collect-js-hidden]="submittingPayment">
        <div class="pay-with-row">
          <span class="pay-with-label">Pay with:</span>
          <div class="toggle-group">
            <button class="toggle-option" type="button" [class.toggle-option--active]="paymentType === achType"
              [disabled]="submittingPayment" (click)="setPaymentType(achType)">ACH</button>
            <button class="toggle-option" type="button" [class.toggle-option--active]="paymentType === cardType"
              [disabled]="submittingPayment" (click)="setPaymentType(cardType)">Card</button>
          </div>
        </div>

        @if (iFrameSrc) {
        <iframe #paymentFrame id="tokenize_{{formId}}" style="border: none; width: 100%;"
          [style.min-height]="isAchType() ? '450px' : '210px'" scrolling="no" [src]="iFrameSrc"></iframe>
        }

        <!-- TODO: leaving this so we can reference connecting with NMI -->
        <!-- @if (isCardType()) {
        <div class="collect-input-placeholder">
          <div id="cc-number"></div>
        </div>
        <div class="collect-input-placeholder">
          <div id="cc-exp"></div>
        </div>
        <div class="collect-input-placeholder">
          <div id="cvv"></div>
        </div>
        }

        @if (isAchType()) {
        <div class="collect-input-placeholder">
          <div id="check-acct"></div>
        </div>
        <div class="collect-input-placeholder">
          <div id="check-aba"></div>
        </div>
        <div class="collect-input-placeholder">
          <div id="check-name"></div>
        </div>
        } -->

        @if (!isAchType()) {
        <button class="confirm-button" id="pay-button" type="button" (click)="enterPaymentInfo($event)"
          [disabled]="submittingPayment || billingFormGroup.invalid">
          Add Payment Method
        </button>
        }
      </div>
    </form>

    @if (paymentError) {
    <p class="payment-error-text">
      The following error occurred: {{paymentError}}. Please try again later.
    </p>
    }
  </div>
</div>